import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { Input } from "~/components/input";

import type { FormState } from "./form-state";

export interface WidgetMinMaxProps {
	className?: string;
	default?: number;
	name: string;
	value: FormState;
}

export const WidgetMinMax: React.FC<WidgetMinMaxProps> = ({ className, default: defaults, name, value }) => {
	const monitor = useMonitor();

	return (
		<Input
			className={className}
			name={name}
			onChange={(event) => value.setInput(event.target.value)}
			placeholder={defaults?.toString() ?? "Default"}
			type="number"
			value={value.getInput(monitor)}
		/>
	);
};
